import styled from 'styled-components';

//components
import { Container } from '@/components/Grid';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const HeroSection = styled.header`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 380px;
  background: ${homeColor.bg};

  ${screen.md} {
    min-height: 460px;
  }

  ${screen.lg} {
    min-height: 560px;
  }

  ${screen.xxlg} {
    min-height: 680px;
  }
`;

export const HeroBg = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

export const HeroVisual = styled.img.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) =>
    prop === 'fetchpriority' || defaultValidatorFn(prop),
})`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 35%;
`;

export const HeroOverlay = styled.div`
  position: absolute;
  inset: 0;
  background:
    linear-gradient(64deg, rgba(0, 0, 0, 0) 34%, rgba(0, 0, 0, 0.2) 87%),
    linear-gradient(
      244deg,
      rgba(1, 203, 44, 0) 40%,
      rgba(1, 203, 44, 0.2) 79%
    ),
    linear-gradient(180deg, rgba(7, 19, 24, 0.1) 0%, ${homeColor.bg} 96%);
`;

export const HeroInner = styled(Container)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
  padding-top: 64px;
  padding-bottom: 40px;

  ${screen.lg} {
    gap: 24px;
    padding-top: 90px;
    padding-bottom: 56px;
  }
`;

export const HeroKicker = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${homeColor.green};
  margin: 0;
`;

export const HeroTitle = styled.h1`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.25;
  font-size: 38px;
  margin: 0;
  color: ${homeColor.white};

  ${screen.lg} {
    font-size: 48px;
  }

  ${screen.xxlg} {
    font-size: 58px;
  }
`;

export const HeroDescription = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: ${homeColor.muted};
  margin: 0;
  max-width: 330px;

  ${screen.md} {
    max-width: 546px;
  }

  ${screen.lg} {
    font-size: 20px;
    max-width: 672px;
  }

  ${screen.xxlg} {
    max-width: 932px;
  }
`;

export const HeroCta = styled.div`
  padding-top: 8px;
`;
